<div class="rounded-md shadow-md bg-white p-8 w-full flex flex-col overflow-auto max-h-full">
  <div class="flex flex-row justify-between items-center">
    <h2 class="mb-2 font-bold">Campingplatz "{{ campsite()?.designation || '' | i18n }}" buchen</h2>
    <button (click)="close()">
      <ng-icon name="heroXMark" class="h-5 w-5 flex-shrink-0" size="24px"></ng-icon>
    </button>
  </div>

  @if (period(); as p) {
    <div class="text-sm">
      <div class="font-bold">
        {{ p.designation | i18n }}
      </div>
      <div class="text-sm">
        {{ formatDate(p.from) }} -
        {{ formatDate(p.until) }}
      </div>
    </div>

    @switch (displayType | async) {
      @case ('success') {
        <div class="flex flex-row items-center my-12">
          <ng-icon name="heroCheckCircle" size="32px" class="mr-4 text-green-700"></ng-icon>
          <div class="flex flex-col">
            <h3 class="mb-2">{{ { key: 'bookingSuccess' } | i18n }}</h3>
            <!-- <p class="text-sm">{{ { key: 'bookingConfirmationEmail' } | i18n }}</p> -->
          </div>
        </div>
        <button
          class="w-full items-center justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 bg-primary-600 hover:bg-primary-700 focus:ring-primary-500"
          (click)="close(true)"
        >
          {{ { key: 'close' } | i18n }}
        </button>
      }
      @case ('error') {
        <div class="flex flex-row items-center my-12">
          <ng-icon name="heroXCircle" size="32px" class="mr-4 text-red-600"></ng-icon>
          <h3 class="mb-0">{{ { key: 'bookingError' } | i18n }}</h3>
        </div>
        <button
          class="w-full items-center justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 bg-primary-600 hover:bg-primary-700 focus:ring-primary-500"
          (click)="close()"
        >
          {{ { key: 'close' } | i18n }}
        </button>
      }
      @case ('loading') {
        <div class="flex flex-row items-center my-12">
          <app-loading [classes]="['h-6', 'w-6', 'mr-4']" [noWhitespace]="true" [hideText]="true"></app-loading>
          <h3 class="mb-0">{{ { key: 'pleaseWait' } | i18n }}</h3>
        </div>
      }
      @case ('redirectToPayment') {
        <div class="flex flex-row items-center my-12">
          <ng-icon name="heroArrowUpRight" size="32px" class="mr-4 text-gray-500"></ng-icon>
          <h3 class="mb-0">{{ { key: 'redirectToPayment' } | i18n }}</h3>
        </div>
      }
      @default {
        <div class="mt-8">
          <label for="payment-method-select" class="block text-sm leading-6 text-gray-900 font-bold">{{
            { key: 'paymentMethod', n: 1 } | i18n
          }}</label>
          <select
            id="payment-method-select"
            name="payment-method-select"
            class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary-600 sm:text-sm sm:leading-6"
          >
            @for (item of paymentMethods | async; track item._id) {
              <option [value]="item._id">{{ item.displayValue | i18n }}</option>
            }
          </select>
        </div>

        <div class="mt-8 text-sm h-24 flex flex-col justify-center">
          <div class="flex flex-row justify-between">
            <div class="font-bold">{{ { key: 'priceInclVat' } | i18n }}</div>
            <div class="font-bold">{{ p.priceInclVat | bbitFormatPrice }}</div>
          </div>
        </div>

        <!---@if (legalFiles | async; as files) {
        @if (files.length > 0) {
          <p class="mt-8 mb-4 text-sm">{{ { key: 'acceptConditions' } | i18n }}</p>
          <div class="flex flex-col gap-2">
            @for (file of files; track file._id) {
              <div class="relative flex flex-row items-center justify-between">
                <div class="relative flex flex-row items-center">
                  <div class="flex h-6 items-center">
                    <input
                      id="legal-file-{{ file._id }}"
                      type="checkbox"
                      class="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                      [ngModel]="acceptedLegalFiles().includes(file._id)"
                      (ngModelChange)="toggleAcceptedLegalFile(file._id)"
                    />
                  </div>
                  <div class="ml-3 text-sm leading-6">
                    <label for="legal-file-{{ file._id }}" class="font-medium text-gray-900">{{ file.designation | i18n }}</label>
                  </div>
                </div>
                <a
                  [href]="getDownloadUrl(file)"
                  target="_blank"
                  class="ml-4 text-sm text-gray-500 hover:text-primary-600 flex flex-row items-center space-x-2"
                >
                  <ng-icon name="heroArrowDownLeft"></ng-icon>{{ { key: 'download' } | i18n }}
                </a>
              </div>
            }
          </div>
        }
      } -->

        <button
          class="bg-primary-600 hover:bg-primary-700 focus:ring-primary-500 mt-8 w-full items-center justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50"
          (click)="book()"
        >
          {{ { key: 'book' } | i18n }}
        </button>
        <button
          class="mt-4 w-full items-center justify-center text-primary-600 hover:text-primary-700 rounded-md border border-transparent py-2 px-4 text-sm font-medium focus:outline-none"
          (click)="close()"
        >
          {{ { key: 'cancel' } | i18n }}
        </button>
      }
    }
  }
</div>
